import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const markAsRead = (data: any, cb: (message: string, status: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {

        let url: string = `/voicemail`;

        networkCall("put", url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(res.data.message, true);
                } else {
                    cb(res.data.message, false);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    let message = error.response.data.message;

                    // update error message to make use readable
                    if (error?.response?.data?.error?.scalar) {
                        message = error?.response?.data?.error?.scalar;  
                    }

                    cb(message, false);
                }
            });
    }
}